import React, { useMemo } from 'react';
import { Button as RBButton, Tooltip, OverlayTrigger, ButtonProps } from 'react-bootstrap';
import { Icon } from 'components/Icon';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

interface CustomButtonProps extends ButtonProps {
    label?: string | false
    loading?: boolean
    loadingLabel?: React.ReactNode
    outline?: boolean
    tooltip?: string | null
}

const Button = ({
    label = false,
    loading = false,
    loadingLabel = null,
    size = 'lg',
    outline = false,
    variant = 'primary',
    tooltip = null,
    disabled = false,
    ...props
}: CustomButtonProps) => {
    const { children } = props;
    const insideVariant = useMemo(() => {
        return outline ? `outline-${variant}` : variant;
    }, [outline, variant]);

    const buttonLabel = useMemo(() => {
        if (loading) {
            return (
                <>
                    <Icon 
                        icon={faSpinner} 
                        spin 
                        className={loadingLabel ? 'mr-3' : ''} 
                    />
                    {loadingLabel}
                </>
            );
        }

        return label || children;
    }, [loading, label, children, loadingLabel]);

    const renderButton = () => {
        const button = (
            <RBButton {...props} variant={insideVariant} size={size} disabled={disabled}>
                {buttonLabel}
            </RBButton>
        );

        if (tooltip) {
            return (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`button-tooltip-${insideVariant}`}>{tooltip}</Tooltip>}
                >
                    {button}
                </OverlayTrigger>
            );
        }

        return button;
    };

    return buttonLabel ? renderButton() : <>children</>;
};

export default Button;